/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useEffect, useState} from 'react';
import {Button, Table, TableColumnsType} from "antd";
import styles from './FCMMessage.module.scss';
import {FCMMessageType} from "../../types/FCMMessageType";
import PageTitle from "../../components/common/PageTitle/PageTitle";
import MessageSendPopup from "./popup/MessageSendPopup";

const columns: TableColumnsType<FCMMessageType> = [
	{
		title: 'ID',
		dataIndex: 'id',
		key: 'id',
		width: 50,
		align: 'center',
	},
	{
		title: '유형',
		dataIndex: 'type',
		key: 'type',
		width: 30,
		align: 'center',
	},
	{
		title: 'notification key',
		dataIndex: 'notificationKey',
		key: 'notificationKey',
		width: 50,
		align: 'center',
	},
	{
		title: 'tpl params',
		dataIndex: 'tplParams',
		key: 'tplParams',
		width: 200,
		align: 'center',
	},
	{
		title: 'data',
		dataIndex: 'data',
		key: 'data',
		width: 200,
		align: 'center',
	},
	{
		title: '수신자',
		dataIndex: 'receivers',
		key: 'receivers',
		width: 100,
		align: 'center',
	},
	{
		title: '발송일시',
		dataIndex: 'msgSentAt',
		key: 'msgSentAt',
		width: 60,
		align: 'center',
	},
	{
		title: '발송예정일시',
		dataIndex: 'msgScheduledAt',
		key: 'msgScheduledAt',
		width: 60,
		align: 'center',
	},
];

const FcmMessage = () => {
	const [list, setList] = useState<FCMMessageType[]>([]);
	const [isOpenPopup, setIsOpenPopup] = useState(false);

	useEffect(() => {

	}, []);

	const onSend = () => {
		setIsOpenPopup(false);
		// todo fetch
	};

	return (
		<div className={styles.wrap}>
			<div className={styles.topWrap}>
				<PageTitle title="FCM 메시지"/>
				<Button type="primary" onClick={() => setIsOpenPopup(prev => !prev)}>
					메시지 작성
				</Button>
			</div>

			<Table
				bordered
				pagination={false}
				columns={columns}
				dataSource={list.map((row) => ({...row, key: row.id}))}
			/>

			{isOpenPopup && (
				<MessageSendPopup
					showPopup={isOpenPopup}
					onCancel={() => setIsOpenPopup(false)}
					onSend={onSend}
				/>
			)}
		</div>
	);
};

export default FcmMessage;
